import { render } from "./FriendCard-SendInvite.vue?vue&type=template&id=2f4d7607&scoped=true"
import script from "./FriendCard-SendInvite.vue?vue&type=script&lang=js"
export * from "./FriendCard-SendInvite.vue?vue&type=script&lang=js"

import "./FriendCard-SendInvite.vue?vue&type=style&index=0&id=2f4d7607&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4d7607"]])

export default __exports__